<div class="overview-page">
  <div>
    <h1>{{'Module_Overview_Page_Title' | translate}}</h1>
  </div>

  <div *ngIf="!isStudent">
    {{'Module_Overview_Functionality_Only_For_Students' | translate}}
  </div>

  <div *ngIf="isStudent  && !loading">
    <div *ngIf="studentCurriculum">
      <div *ngIf="contextCourse">
        <div fxLayout="row" class="page-content-columns">

          <!-- Left side -->
          <div fxFlex="auto" class="left-side">
            <div [innerHTML]="contextCourse.infoText"></div>
            <div></div>

            <!--multiple phases-->
            <div *ngIf="isMultiPhaseCourse">
              <div fxLayout="column" *ngFor="let phase of contextCoursePhases">
                <div class="phase-container">
                  <mat-accordion displayMode="flat" multi="true">
                    <mat-expansion-panel class="accordion-panel" hideToggle expanded="true">
                      <mat-expansion-panel-header class="accordion-header">
                        <mat-panel-title class="accordion-title">
                          <h2>{{phase.name}}</h2>
                        </mat-panel-title>
                        <mat-icon svgIcon="expand_more" class="expand"></mat-icon>
                      </mat-expansion-panel-header>
                      <div *ngFor="let module of phase.modules">
                        <div *ngIf="isModuleInFilter(module.status, module.name)" fxLayout="row" class="module-item">
                          <div fxFlex="auto">
                            <div fxLayout="row">
                              <div [ngClass]="isExemptionOrUnavailable(module) ? 'unavailable' : 'module-name'">
                                <h3>
                                  <a href="javascript:void(0)" (click)="goToModuleDetails(studentCurriculum.studentEid,module)">
                                    {{module.name}} {{module.defaultCredits? '(' + module.defaultCredits + ' ' + getDefaultCreditsUnit() + ')' : ''}}
                                  </a>
                                </h3>
                              </div>
                            </div>
                          </div>
                          <div fxFlex="none" [ngClass]="{'right-aligned-item': true, 'unavailable' : isExemptionOrUnavailable(module)}">
                            {{module.statusText}}
                          </div>
                          <div class="module-status-icon-div">
                            <mat-icon [ngClass]="getModuleIconClass(module)"></mat-icon>
                          </div>
                        </div>
                      </div>
                    </mat-expansion-panel>
                  </mat-accordion>
                </div>
              </div>
            </div>

            <div *ngIf="!isMultiPhaseCourse" class="single-phase-container">
              <div fxLayout="column" *ngFor="let phase of contextCoursePhases">
                <div class="phase-container">
                  <div *ngFor="let module of phase.modules">
                    <div *ngIf="isModuleInFilter(module.status, module.name)" fxLayout="row" class="module-item">
                      <div fxFlex="auto">
                        <div fxLayout="row">
                          <div [ngClass]="isExemptionOrUnavailable(module) ? 'unavailable' : 'module-name'">
                            <h3>
                              <a href="javascript:void(0)" (click)="goToModuleDetails(studentCurriculum.studentEid,module)">
                                {{module.name}} {{module.defaultCredits? '(' + module.defaultCredits + ' ' + getDefaultCreditsUnit() + ')' : ''}}
                              </a>
                            </h3>
                          </div>
                        </div>
                      </div>
                      <div fxFlex="none" [ngClass]="{'right-aligned-item': true, 'unavailable' : isExemptionOrUnavailable(module)}">
                        {{module.statusText}}
                      </div>
                      <div class="module-status-icon-div">
                        <mat-icon [ngClass]="getModuleIconClass(module)"></mat-icon>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <!-- Right side -->
          <div fxFlex="298px">
            <div fxLayout="column" fxLayoutGap="25px">
              <div id="status" fxFlex="auto" class="rounded-box">
                <div><h3>{{'Module_Overview_Status_Progress' | translate}}</h3></div>
                <div>
                  <div fxLayout="row">
                    <div fxFlex="60">{{'Module_Overview_Status_CompletedModules' | translate}}:</div>
                    <div fxFlex="40" class="right-aligned-item">{{getFinishedModuleCount(contextCourse)}} {{'Module_Overview_Status_From' | translate}} {{contextCourse.modules.length}}</div>
                  </div>
                  <div fxLayout="row" *ngIf="contextCourse.programmeLevel != 'COURSE' && contextCourse.serviceContract.courseVariant != CourseVariant.HBOPB && contextCourse.serviceContract.courseVariant != CourseVariant.HBOMI">
                    <div fxFlex="60">{{'Module_Overview_Status_Earned' | translate}} {{getDefaultCreditsUnit()}}:</div>
                    <div fxFlex="40" class="right-aligned-item">{{getEarnedCredits(contextCourse)}} {{'Module_Overview_Status_From' | translate}} {{contextCourse.defaultCredits}}</div>
                  </div>
                  <div fxLayout="row" class="progressbar-container">
                    <progress class="progressbar" max="100" [value]="getEarnedCreditsProgress(contextCourse)">
                    </progress>
                  </div>
                </div>
              </div>
              <div id="filter" fxFlex="auto" class="rounded-box">
                <div fxLayout="column">
                  <h3>{{'Module_Overview_Filter_Title' | translate}}</h3>
                  <div><h4>{{'Module_Overview_Filter_By_Name' | translate}}</h4></div>
                  <div class="search-box">
                    <input [(ngModel)]="searchFilter" placeholder="{{'Module_Overview_Search_Module' | translate}}" class="search-input" (ngModelChange)="onSearchByNameChanged()">
                    <div class="search-icon"><mat-icon svgIcon="search"></mat-icon></div>
                  </div>
                  <h4>{{'Module_Overview_Filter_Show_Only_Status' | translate}}</h4>
                  <div><mat-checkbox (change)="checkboxChanged($event, 'activated')">{{'Module_Overview_Filter_Activated' | translate}} ({{getFilterCount("activated")}})</mat-checkbox></div>
                  <div><mat-checkbox (change)="checkboxChanged($event, 'always_active')">{{'Module_Overview_Filter_Always_Active' | translate}} ({{getFilterCount("always_active")}})</mat-checkbox></div>
                  <div><mat-checkbox (change)="checkboxChanged($event, 'available')">{{'Module_Overview_Filter_To_Be_Activated' | translate}} ({{getFilterCount("available")}})</mat-checkbox></div>
                  <div><mat-checkbox (change)="checkboxChanged($event, 'finished')">{{'Module_Overview_Filter_Completed' | translate}} ({{getFilterCount("finished,exemption")}})</mat-checkbox></div>
                  <div><mat-checkbox (change)="checkboxChanged($event, 'unavailable')">{{'Module_Overview_Filter_Not_Available' | translate}} ({{getFilterCount("unavailable")}})</mat-checkbox></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
